require('./troubleshoot-template.html');
require('./troubleshoot.style.less');

var webRTCTroubleshooter = require('webrtc-troubleshoot').default;
var TestSuite = require('./test-suite');

angular.module('bbl.module.troubleshoot', [])
.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/troubleshoot', {
        templateUrl: 'troubleshoot-template.html',
        controller: 'TroubleshootController',
        joinCallRoute: true,
        invitedLayout: true,
    });
}])
.controller('TroubleshootController', [
    '$scope', 'ICE_SERVERS', '$timeout',
    TroubleshootController
]);

function runTests() {

}

function TroubleshootController($scope, iceServers, $timeout) {
  $scope.state = {};

  $scope.tests = {
    audio: {status: null, name: 'Microphone', test: null},
    network: {status: null, name: 'Network', test: null},
    connectivity: {status: null, name: 'Connectivity', test: null},
    throughput: {status: null, name: 'Throughput', test: null},
  };

  var noop = angular.noop;
  var mediaOptions = { audio: true };
  var iceConfig = { iceServers: iceServers };

  function setTestStatus(testName, status) {
    $timeout(function() {
      $scope.tests[testName].status = status;
    });
  }

  $scope.startTest = function() {
    $scope.state.status = 'running';

    var testSuite = new TestSuite({onNext: function(test) {
      Object.keys($scope.tests).forEach(function(k) {
        if($scope.tests[k].test !== test) {
          return;
        }
        setTestStatus(k, 'init');

        test.promise.then(
          setTestStatus.bind(this, k, 'success'),
          setTestStatus.bind(this, k, 'fail')
        );
      });
    }});

    // AUDIO tests
    var audioTest = new webRTCTroubleshooter.AudioTest(mediaOptions);
    audioTest.promise.then(noop, function(err) {
      var audioErrors = {
        NotAllowedError: 'Your browser has blocked BrandedBridgeLine from accessing your microphone. Please enable access to your microphone, once you do so the tests will automatically begin.',
        default: 'Please ensure your computer and browser are properly detecting the intended microphone and verify the volume is turned up.',
      };

      $scope.tests.audio.failReason = audioErrors[err.name || 'default'] || audioErrors.default;
    });
    testSuite.addTest(audioTest);
    $scope.tests.audio.test = audioTest;

    if (window.RTCPeerConnection) {
      var connectivityTest = new webRTCTroubleshooter.ConnectivityTest(iceConfig);
      $scope.tests.connectivity.test = connectivityTest;

      var throughputTest = new webRTCTroubleshooter.ThroughputTest(iceConfig);
      $scope.tests.throughput.test = throughputTest;

      var symmetricNatTest = new webRTCTroubleshooter.SymmetricNatTest();
      $scope.tests.network.test = symmetricNatTest;

      testSuite.addTest(connectivityTest);
      testSuite.addTest(symmetricNatTest);
      testSuite.addTest(throughputTest);
    }

    testSuite.start().then(function (results) {
      var result = 'Finished the tests';
      $scope.state.status = 'success';
      console.log(result, results);
    }, function (err) {
      var result = 'test failure';
      $scope.state.status = 'fail';
      console.warn(result, err, err.details);
    });
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/troubleshoot/troubleshoot.module.js
 ** module id = 408
 ** module chunks = 0
 **/